import React from "react";
import { List, ListItemButton, ListItemIcon, ListItemText, Collapse } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { theme } from "../../../Theme";

const CollapsibleList = ({ title, icon, items = [], openInitially = true, drawerOpen, setTitle}) => {
  const hasHeader = Boolean(title || icon);
  const [open, setOpen] = React.useState(openInitially);

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  

  const ListTitleText = {
    fontSize: theme.typography.fontSize.xsmall,
    color: theme.palette.accent.main,
    fontWeight: theme.typography.fontWeightBold,
    display: drawerOpen? "block": "none"
  };

  const ListTitleIcon = {
    color: theme.palette.accent.main,
    minWidth: 0,
    mr:1,
    justifyContent: 'center',
  };
  const ExpandIcon={
    color: theme.palette.accent.main,
  }

  return (
    <>
      {hasHeader && (
        <ListItemButton sx={{ justifyContent: drawerOpen ? 'initial' : 'center' }} onClick={handleClick}>
          {icon && <ListItemIcon sx={ListTitleIcon}>{icon}</ListItemIcon>}
          {title && <ListItemText sx={ListTitleText} primary={title} />}
          {open ? <ExpandLess sx={ExpandIcon}/> : <ExpandMore sx={ExpandIcon}/>}
        </ListItemButton>
      )}
      <Collapse in={!hasHeader || open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items.map((item, index) => (
            <ListItemButton
              key={item.subPath || item.text || index}
              aria-label={item.text}
              sx={{
                bgcolor: item.activeCondition === item.active ? theme.palette.primary.main : theme.palette.secondary.main,
                borderRadius: "25px",
                height:36,
                mx:0.5,
                justifyContent: drawerOpen ? 'initial' : 'center',
                ":hover":{
                  backgroundColor: item.activeCondition === item.active && theme.palette.primary.main
                }
              }}
              onClick={() => {item.onClick(item.subPath, item.text); setTitle && setTitle(item.text);}}
              disabled={item.disabled}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mx:1,
                  justifyContent: 'center',
                  color: item.activeCondition === item.active ? theme.palette.secondary.main : theme.palette.primary.dark,
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText sx={{ fontSize: theme.typography.fontSize.xxsmall,
                  color: item.activeCondition === item.active ? theme.palette.secondary.main : theme.palette.primary.dark,
                  display: drawerOpen && !item.hideText ? "block": "none"
                 }} primary={item.text} />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default CollapsibleList;
